import { render } from "./classify.vue?vue&type=template&id=0ecbc900&scoped=true"
import script from "./classify.vue?vue&type=script&lang=js"
export * from "./classify.vue?vue&type=script&lang=js"

import "./classify.vue?vue&type=style&index=0&id=0ecbc900&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecbc900"]])

export default __exports__